import { orange } from "wg-fe-ui/dist/themes";

export let currentTheme = {};

export function getThemeObject() {
  return orange();
}
